import { getDesktopBridge, isStockForgeDesktop } from "./desktopShell";

export const LEGEND_SITE_URL = "https://robinhood.com/legend/";

export type LegendOpenContext = "puts" | "calls" | "options" | "stocks" | "history";
export type LegendChainMode = "sell-put" | "sell-call";

export function legendChainModeForContext(kind: LegendOpenContext): LegendChainMode | undefined {
  if (kind === "puts") return "sell-put";
  if (kind === "calls") return "sell-call";
  return undefined;
}

export function legendWidgetIdsForContext(kind: LegendOpenContext): string[] {
  if (kind === "puts" || kind === "calls") return ["chart", "options-chain"];
  if (kind === "options") return ["chart", "options-chain", "positions"];
  if (kind === "stocks") return ["chart", "positions"];
  return ["chart"];
}

export function legendKindFromActiveTab(): LegendOpenContext | null {
  const selected = document.querySelector<HTMLElement>('[role="tab"][aria-selected="true"][data-tab]');
  const tab = selected?.dataset.tab?.trim() || activePanelTab() || activeWheelView();
  if (!tab) return null;
  if (tab === "puts" || tab === "puts-plus") return "puts";
  if (tab === "calls" || tab === "calls-plus") return "calls";
  if (tab === "options") return "options";
  if (tab === "stocks") return "stocks";
  if (tab === "history" || tab === "history-local" || tab === "history-sf") return "history";
  // Retired Focus / Focus+ tabs.
  if (tab === "focus" || tab === "focus4") return "options";
  return null;
}

function activePanelTab(): string {
  const panels = document.querySelectorAll<HTMLElement>(".sfe-web-panel[data-panel]");
  for (const panel of panels) {
    const hidden = panel.getAttribute("hidden");
    if (hidden === "" || hidden === "true") continue;
    const id = panel.dataset.panel?.trim();
    if (id) return id;
  }
  return "";
}

function activeWheelView(): string {
  const view = document.querySelector<HTMLElement>("[data-wheel-view]");
  return view?.getAttribute("data-wheel-view")?.trim() || "";
}

export function openLegendForContext(kind: LegendOpenContext, ticker?: string): boolean {
  const resolved = legendKindFromActiveTab() ?? kind;
  const ids = legendWidgetIdsForContext(resolved);
  const symbol = ticker?.trim() || "";
  const desktop = getDesktopBridge();

  if (isStockForgeDesktop() && desktop) {
    const chain = legendChainModeForContext(resolved);
    if (desktop.openLegendWidgets) {
      void desktop.openLegendWidgets({ ids, ticker: symbol, chain });
      return true;
    }
    if (desktop.openLegendWidget) {
      for (const id of ids) void desktop.openLegendWidget(id);
      return true;
    }
  }

  window.open(LEGEND_SITE_URL, "sfe-legend");
  return true;
}
